import { Table, Input, InputNumber, Popconfirm, Form, Select, Button, Icon , notification } from "antd";
import React from "react";
import reportService from "service/reportService";
const { Option } = Select;





const EditableContext = React.createContext();

class EditableCell extends React.Component {
  state = {
    options: [], 
    loading: true, 
  };
  componentDidUpdate(prevProps) {
      if((this.props.asyncDropdownValues && this.props.asyncDropdownValues.values && this.props.asyncDropdownValues.values.length && !this.state.options.length)){
        this.setState({options : this.props.asyncDropdownValues.values});
        return true
      }
  }
  
  componentDidMount(){
    if(this.props.dropDownValues){
      this.setState({options : this.props.dropDownValues});
    }
    if((this.props.asyncDropdownValues && this.props.asyncDropdownValues.values && this.props.asyncDropdownValues.values.length)){
      this.setState({options : this.props.asyncDropdownValues.values});
    }
  }
  
  getInput = () => {
    let {inputType , disableOnEditScreen} = this.props;
    if (inputType === "number") {
      return <InputNumber disabled={disableOnEditScreen} />;
    }
    if (inputType === "dropdown") {
      return (
        <Select disabled={disableOnEditScreen} style={{width : this.props.dropdownWidth || "200px"}} showSearch>
            {this.state.options.map(role => (
            <Option key={role} value={role}>
                {role}
            </Option>
            ))}
        </Select>
      );
    }
    return <Input disabled={disableOnEditScreen} />;
  };

  renderCell = ({ getFieldDecorator }) => {
    const {
      editing,
      dataIndex,
      title,
      inputType,
      record,
      index,
      children,
      dropDownValues,
      asyncDropdownValues,
      validationRules,
      dropdownWidth,
      isNotRequired,
      disableOnEditScreen,
      ...restProps
    } = this.props;
    return (
      <td {...restProps}>
        {editing ? (
          <Form.Item style={{ margin: 0 }}>
            {getFieldDecorator(dataIndex, {
              rules: validationRules || [
                {
                  required: !isNotRequired,
                  message: `Please Input ${title}!`,
                },
              ],
              initialValue: inputType == 'number' && record && record[dataIndex] ?  parseInt(record[dataIndex]) : record[dataIndex] ,
            })(this.getInput())}
          </Form.Item>
        ) : (
          children
        )}
      </td>
    );
  };
  

  render() {
    return (
      <EditableContext.Consumer>{this.renderCell}</EditableContext.Consumer>
    );
  }
}

class EditableTable extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      editingKey: "",
      isTableLoading: false,
      currentPage: 1,
      searchText: '',
      searchedColumn: '',
      sortOrder: null,
      selectedRowKeys: []
    };
    this.triggerDropdownReports = this.triggerDropdownReports.bind(this);

    this.columns = [
      ...(this.props.columns || []),
      {
        title: "Operations",
        dataIndex: "operation",
        width: "15%",
        render: (text, record) => {
          const { editingKey } = this.state;
          const editable = this.isEditing(record);
          return editable ? (
            <span>
              <EditableContext.Consumer>
                {(form) => (
                  <a
                    onClick={() => this.save(form, record.key)}
                    style={{ marginRight: 8 }}
                  >
                    Save
                  </a>
                )}
              </EditableContext.Consumer>
              <Popconfirm
                title="Sure to cancel?"
                onConfirm={() => this.cancel(record.key)}
              >
                <a>Cancel</a>
              </Popconfirm>
            </span>
          ) : (
            <div style={{display : "flex", flexDirection : "row", gap : "10px"}}>
            <a
              disabled={editingKey !== ""}
              onClick={() => this.edit(record.key)}
            >
              Edit
            </a>
            <Popconfirm
                title="Sure to Delete?"
                onConfirm={() => {
                  let foundData = record;
                  let findTheDeleteFilter = this.props.columns.filter(e=> e.deleteFilter)
                  this.setState({isTableLoading : true}, ()=>{
                    reportService.deleteFromElastic(this.props.indexToInsert, findTheDeleteFilter.map(e=>{
                      return { columnName: e.dataIndex, columnValue: [foundData[e.dataIndex]]}
                    })).then(e=>{
                      this.callSecData();
                    })
                  });
                }}
              >
                <a
              disabled={editingKey !== ""}
              
            >
              Delete
            </a>
              </Popconfirm>
            
            </div>
          );
        },
      },
    ];
    this.paginationRef = React.createRef();
  }
  openNotificationWithIcon = (type, message) => {
    notification[type]({
      message: message.title,
      description:
       message.description,
    });
  };
  callSecData = async (shouldNavigateToLast) => {
     reportService.fetchReport(
      this.props.queryToGet,
      [],
      []
    ).then(e => {
        let data  =  (e.data&& e.data.response && JSON.parse(e.data.response) || []).map(e=> ({...e,key : JSON.stringify(e)}))
        window[this.props.queryToGet] = data;
        this.triggerDropdownReports();
        this.setState({data : data, isTableLoading : false},()=>{
          if(shouldNavigateToLast){
            this.setState({currentPage : Math.ceil(this.paginationRef.current.props.total / this.paginationRef.current.props.pageSize)})
          }
        });
    });
  };
  isEditing = (record) => record.key === this.state.editingKey;

triggerDropdownReports=()=>{

  let that = this;
  (this.props.columns || []).map(g=>{
    if(g.asyncDropdownValues){
      let { column, reportName , setReportInWindowVar, dropdownFilters} = g.asyncDropdownValues;
      reportService.fetchReport(
            reportName,
            [],
            []
          ).then(e=>{
            let data  =  (e.data&& e.data.response && JSON.parse(e.data.response) || [])
            
            let timer11 = setInterval(()=>{
              let targetReportData = window[that.props.queryToGet];
              if(targetReportData){
                
                if(dropdownFilters){
                
                  let {sourceKey, targetKey} = dropdownFilters;
                  data = data.filter(e=>!targetReportData.map(f=>f[targetKey]).includes(e[sourceKey]));
                }
                g.asyncDropdownValues.values = (data || []).map(e=> e[column]);
                window.landing_reports = window.landing_reports || {};
                if(setReportInWindowVar){
                  window.landing_reports[reportName] = data
                }
                clearInterval(timer11);
              }
            },100)
          })
    }
  })
}
  componentDidMount() {
    this.callSecData();
    this.triggerDropdownReports();
  }
  componentDidUpdate(prevProps, prevState) {
    if ((!prevProps.modalVisibility && this.props.modalVisibility) || (!prevProps.visibilityKey && this.props.visibilityKey)) {
        this.setState({isTableLoading : true, data : []}, ()=>{
            this.callSecData();
        });
        
    }
  }
  cancel = () => {
    if(this.state.newDataKey && this.state.newDataKey.length){
        this.setState({data : this.state.data.filter(e=> e.key != this.state.newDataKey)})
    }
    this.setState({ editingKey: "", newDataKey :"" });
  };
  generateColumnValues =(row)=>{
    return (this.props.columns || []).reduce((acc,c)=>{
      let newObj =  { columnName: c.dataIndex , columnValue: (c.customValidate ? c.customValidate(row[c.dataIndex]) : row[c.dataIndex])};
      acc = [...acc,newObj]
      return acc
    },[])
  }
  save = (form, key) => {
    debugger
    form.validateFields((error, row) => {
      debugger
      if (error) {
        return;
      }
      let {editingKey, newDataKey} = this.state;
      const newData = [...this.state.data];
      const index = newData.findIndex((item) => key === item.key);
      let isNewInsert = newDataKey && newDataKey.length && (editingKey === newDataKey);
      let foundData = isNewInsert ? row : JSON.parse(JSON.stringify(newData[index]));
      const isUnchanged = Object.keys(row).every((field) => {
        return row[field] == foundData[field];
      });
  
      if (isUnchanged && !isNewInsert) {
        this.openNotificationWithIcon('info', { title: "Info", description: "No changes detected." });
        return;
      }
      if (index > -1) {
        const item = newData[index];
        newData.splice(index, 1, {
          ...item,
          ...row,
        });
        let template = {
            columns: [],
          };
         let currentObj = [
            ...this.props.hardCodedInserts(row),
            ...this.generateColumnValues(row)
         ];

        let foundAliasColumns = this.props.columns.find(e=>e.aliasColumns);
        if(foundAliasColumns && isNewInsert){
          let aliasColumns = foundAliasColumns.aliasColumns;
          let {valuetoInsert, valuetoChange, valueColumn} = aliasColumns
          let reportforAlias = foundAliasColumns.asyncDropdownValues.reportName;
          let tableReport = window.landing_reports[reportforAlias];
          let aliasToInsert = tableReport.find(i=>isNewInsert ? i[valuetoChange] == row[valuetoInsert]: i[valueColumn] == row[valuetoInsert])[valueColumn];
          currentObj.find(i=>{if(i.columnName == valuetoInsert){
            i.columnValue = aliasToInsert
          }});
        }
        template.columns = currentObj;
        this.setState({isTableLoading : true});
        let findTheDeleteFilter = this.props.columns.filter(e=> e.deleteFilter);
        let generatedDeleteFilters = findTheDeleteFilter.map(e=>{
          return { columnName: e.dataIndex, columnValue: [isNewInsert? currentObj.find(q=> q.columnName == e.dataIndex)["columnValue"] : foundData[e.dataIndex]]}
        });
        if(isNewInsert){
          if(this.props.combinedFilters){
            reportService.fetchReport(
              this.props.queryToGet,
              generatedDeleteFilters,
              []
            ).then(e=>{
              let data  =  (e.data&& e.data.response && JSON.parse(e.data.response) || []);
              if(data && data.length){
                this.openNotificationWithIcon('error', {title : "Error", description : `The entered combination for ${findTheDeleteFilter.map(e=> e.dataIndex).join(", ")} already has an entry`});
                this.setState({isTableLoading : false});
                return
              }
              reportService.insertMultiple(this.props.indexToInsert, [template]).then(e=>{
                this.setState({ data: newData, editingKey: "", newDataKey : "" }, ()=>{
                  this.openNotificationWithIcon('success', {title : "Success", description : `Data Inserted Successfully`});
                    this.callSecData(true);
                });
            });
            })
          }else{
            let checkFilter = findTheDeleteFilter.reduce((acc,curr)=>{
              acc= { ...acc , [curr.dataIndex] :  currentObj.find(q=> q.columnName == curr.dataIndex)["columnValue"] }
              return acc 
            },{});
            let foundAlready = Object.keys(checkFilter).filter(q=>{
                return this.state.data.find(t=> t[q] == checkFilter[q])
            });
              if(foundAlready && foundAlready.length){
                this.openNotificationWithIcon('error', {title : "Error", description : `The entered ${foundAlready.join(", ")} already has an entry`});
                this.setState({isTableLoading : false});
                return
              }
              reportService.insertMultiple(this.props.indexToInsert, [template]).then(e=>{
                this.setState({ data: newData, editingKey: "", newDataKey : "" }, ()=>{
                  this.openNotificationWithIcon('success', {title : "Success", description : `Data Inserted Successfully`});
                    this.callSecData(true);
                });
            });
          } 
        }else{
            reportService.deleteFromElastic(this.props.indexToInsert, generatedDeleteFilters).then(e=>{
                reportService.insertMultiple(this.props.indexToInsert, [template]).then(e=>{
                    this.setState({ data: newData, editingKey: "", newDataKey : "" }, ()=>{
                        this.openNotificationWithIcon('success', {title : "Success", description : `Data Edited Successfully`});
                        this.callSecData(true);
                    })
                });
            })
        }
       
        
      } else {
        newData.push(row);
        this.setState({ data: newData, editingKey: "" });
      }
    });
  };

  edit = (key) => {
    this.setState({ editingKey: key });
  };

  handleAdd = () => {
    let columns = this.props.columns.reduce((a,e)=> {
                        a = {...a, [e.dataIndex] : ''}
                        return a
                      }, {});
    const newData = {
      key: Date.now().toString(),
      ...columns
    };
    this.setState(
      { currentPage: 1, newDataKey: newData.key},
      () => {
        this.setState({
          data: [newData , ...this.state.data],
          editingKey: newData.key
        },)
      }
    );
  };

  handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    this.setState({
      searchText: selectedKeys[0],
      searchedColumn: dataIndex,
    });
  };

  handleReset = clearFilters => {
    clearFilters();
    this.setState({ searchText: '' });
  };

  getColumnSearchProps = dataIndex => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
      <div style={{ padding: 8 }}>
        <Input
          ref={node => {
            this.searchInput = node;
          }}
          placeholder={`Search ${dataIndex}`}
          value={selectedKeys[0]}
          onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          style={{ marginBottom: 8, display: 'block' }}
        />
        <Button
          type="primary"
          onClick={() => this.handleSearch(selectedKeys, confirm, dataIndex)}
          icon="search"
          size="small"
          style={{ width: 90, marginRight: 8 }}
        >
          Search
        </Button>
        <Button
          onClick={() => this.handleReset(clearFilters)}
          size="small"
          style={{ width: 90 }}
        >
          Reset
        </Button>
      </div>
    ),
    filterIcon: filtered => (
      <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />
    ),
    onFilter: (value, record) =>
      record[dataIndex]
        ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
        : '',
    onFilterDropdownVisibleChange: visible => {
      if (visible) {
        setTimeout(() => this.searchInput.select(), 100);
      }
    },
    render: text =>
      this.state.searchedColumn === dataIndex ? (
        <span style={{ fontWeight: 'bold' }}>{text}</span>
      ) : (
        text
      ),
  });

  handleTableChange = (pagination, filters, sorter) => {
    this.setState({
      sortOrder: {
        column: sorter.columnKey,
        order: sorter.order,
      },
    });
  };
  handleDelete = () => {
    const { selectedRowKeys, data } = this.state;
    const dataToDelete = data.filter(item => selectedRowKeys.includes(item.key));
    let deleteFilterColumns = [...new Set(this.props.columns.filter(r=> r.deleteFilter).map(e=> e.dataIndex))];
    let deleteFiltersToPass = dataToDelete.reduce((acc,curr)=>{
        deleteFilterColumns.map(t=>{
            acc[t] = acc[t] ? [...acc[t], curr[t]] :  [curr[t]] 
        })
        return acc
    }, {});
    let filters = Object.keys(deleteFiltersToPass).map(e=>{
        return {columnName : e, columnValue : deleteFiltersToPass[e]}
    });
    this.setState({ isTableLoading : true , selectedRowKeys: []}, ()=>{
      reportService.deleteMultiple(this.props.indexToInsert, filters).then(() => {
        this.callSecData()
     });
    });
  };
  
  render() {
    const rowSelection = {
      onChange: (selectedRowKeys) => {
        this.setState({ selectedRowKeys });
      },
      selectedRowKeys: this.state.selectedRowKeys,
    };
    
    const components = {
      body: {
        cell: EditableCell,
      },
    };

    const columns = this.columns.map((col) => {
      let isNewAdd = this.state.newDataKey && this.state.newDataKey.length;
      if (!col.editable) {
        return col;
      }
      return {
        ...col,
        ...this.getColumnSearchProps(col.dataIndex),
        sorter: (a, b) => a[col.dataIndex].localeCompare(b[col.dataIndex]),
        sortOrder: this.state.sortOrder && this.state.sortOrder.column === col.dataIndex ? this.state.sortOrder.order : null,
        onCell: (record) => ({
          record,
          inputType: col.inputType ? col.inputType : "text",
          dataIndex: col.dataIndex,
          title: col.title,
          editing: this.isEditing(record),
          dropDownValues: col.dropDownValues,
          validationRules: col.validationRules,
          dropdownWidth: col.dropdownWidth,
          asyncDropdownValues: col.asyncDropdownValues,
          isNotRequired: col.isNotRequired,
          disableOnEditScreen : isNewAdd ? false : col.disableOnEditScreen,
        }),
      };
    });

    return (
      <div>
        <Button
          onClick={this.handleAdd}
          type="primary"
          style={{ marginBottom: 16 }}
        >
          Add a row
        </Button>
        <Button
          onClick={this.handleDelete}
          type="danger"
          style={{ marginBottom: 16 }}
          disabled={!this.state.selectedRowKeys.length}
        >
          Delete selected rows
        </Button>
        <EditableContext.Provider value={this.props.form}>
          <Table
            loading = {this.state.isTableLoading} 
            components={components}
            bordered
            dataSource={this.state.data}
            columns={columns}
            rowClassName="editable-row"
            pagination={{
              current: this.state.currentPage,
              onChange: (page) => this.setState({ currentPage: page }),
              ref: this.paginationRef,  
            }}
            scroll={{
              x: 'max-content',
            }}
            onChange={this.handleTableChange}
            rowSelection={rowSelection}
          />
        </EditableContext.Provider>
      </div>
    );
  }
}

const EditableFormTable = Form.create()(EditableTable);

export default EditableFormTable;
